import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { addData } from "../../helpers/fackBackend_Helper";

function* getMdnSwapReportResponse({ payload: { searchData } }) {
  try {
    const response = yield call(addData, "/mdnSwapReportList", searchData);
    if (response?.response?.Status) {
      yield put(
        actions.getMndSwapeportRequestListSuccessful(response?.response?.data),
      );
    } else {
      yield put(
        actions.getMdnSwapReportRequestListFailed(response?.response?.Message),
      );
    }
  } catch (error) {
    yield put(actions.getMdnSwapReportRequestListFailed(error));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(
      actions.GET_MDN_SWAP_REPORT_REQUEST_LIST,
      getMdnSwapReportResponse,
    ),
  ]);
}
